export const getIcon = (openingMethodKey: string) => {
  switch (openingMethodKey) {
    case 'rfid': return 'rfid'
    case 'mm_app': return 'byapp'
    case 'remote': return 'remote'
    case 'our_padlock': return 'padlock-new'
    case 'own_padlock': return 'padlock-person'
    default: return 'padlock-closed'
  }
}